var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-555{fill:currentColor;}.cls-2{fill:none;}")),React.createElement("title",{"key":1},"close"),React.createElement("polygon",{"className":"cls-555","points":"24 9.4 22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4","key":2}),React.createElement("rect",{"className":"cls-2","width":"32","height":"32","key":3})]);
}

Close.defaultProps = {"id":"icon","viewBox":"0 0 32 32"};

module.exports = Close;

Close.default = Close;
